// @ts-nocheck
import t from './itemDialog.types';

const initialState = {
  activeView: 0,
  stages: [],
  formData: {},
  stageFormData: {},
  hasVariants: true,
  variants: [],
  variantSchema: [],
  images: [],
  subtotals: { 0: 0 },
  variantsTotals: { 0: 0 },
  chargesTotals: { 0: 0 },
  decorationsTotals: { 0: 0 },
  charges: { 0: [] },
  decorations: { 0: [] },
};

export default function itemDialogReducer(state = initialState, action) {
  switch (action.type) {
    case t.ITEM_DIALOG_SET_ACTIVE_VIEW:
      return {
        ...state,
        activeView: action.payload,
      };

    case t.ITEM_DIALOG_SET_STAGES:
      return {
        ...state,
        stages: action.payload,
      };

    case t.ITEM_DIALOG_ADD_STAGE:
      return {
        ...state,
        stages: [...state.stages, action.payload],
        subtotals: { ...state.subtotals, [action.payload.id]: 0 },
        variantsTotals: { ...state.variantsTotals, [action.payload.id]: 0 },
        chargesTotals: { ...state.chargesTotals, [action.payload.id]: 0 },
        decorationsTotals: { ...state.decorationsTotals, [action.payload.id]: 0 },
        charges: { ...state.charges, [action.payload.id]: [] },
        decorations: { ...state.decorations, [action.payload.id]: [] },
      };

    case t.ITEM_DIALOG_DELETE_STAGE: {
      const stageId = action.payload;
      const { [stageId]: removedSubtotal, ...restSubtotals } = state.subtotals;
      const { [stageId]: removedVariantsTotal, ...restVariantsTotals } =
        state.variantsTotals;
      const { [stageId]: removedChargesTotal, ...restChargesTotals } =
        state.chargesTotals;
      const { [stageId]: removedDecorationsTotal, ...restDecorationsTotals } =
        state.decorationsTotals;
      const { [stageId]: removedCharges, ...restCharges } = state.charges;
      const { [stageId]: removedDecorations, ...restDecorations } =
        state.decorations;
      const { [stageId]: removedStageFormData, ...restStageFormData } =
        state.stageFormData;

      return {
        ...state,
        stages: state.stages.filter((stage) => stage.id !== stageId),
        activeView:
          Number(state.activeView) === Number(stageId) ? 0 : state.activeView,
        subtotals: restSubtotals,
        variantsTotals: restVariantsTotals,
        chargesTotals: restChargesTotals,
        decorationsTotals: restDecorationsTotals,
        charges: restCharges,
        decorations: restDecorations,
        stageFormData: restStageFormData,
      };
    }

    case t.ITEM_DIALOG_SET_STAGE_FORM_DATA:
      return {
        ...state,
        stageFormData: {
          ...state.stageFormData,
          [action.payload.stageId]: {
            ...(state.stageFormData[action.payload.stageId] || {}),
            ...action.payload.data,
          },
        },
      };

    case t.ITEM_DIALOG_SET_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          ...action.payload,
        },
      };

    case t.ITEM_DIALOG_SET_HAS_VARIANTS:
      return {
        ...state,
        hasVariants: action.payload,
      };

    case t.ITEM_DIALOG_SET_SUBTOTAL:
      return {
        ...state,
        subtotals: {
          ...state.subtotals,
          [action.payload.view]: action.payload.subtotal,
        },
      };

    case t.ITEM_DIALOG_SET_VARIANTS_TOTAL: {
      const newVariantsTotal = {
        ...state.variantsTotals,
        [action.payload.view]: action.payload.total,
      };
      return {
        ...state,
        variantsTotals: newVariantsTotal,
        subtotals: {
          ...state.subtotals,
          [action.payload.view]:
            Number(newVariantsTotal[action.payload.view]) +
            Number(state.chargesTotals[action.payload.view]) +
            Number(state.decorationsTotals[action.payload.view]),
        },
      };
    }

    case t.ITEM_DIALOG_SET_CHARGES_TOTAL: {
      const newChargesTotals = {
        ...state.chargesTotals,
        [action.payload.view]: action.payload.total,
      };
      return {
        ...state,
        chargesTotals: newChargesTotals,
        subtotals: {
          ...state.subtotals,
          [action.payload.view]:
            Number(state.variantsTotals[action.payload.view]) +
            Number(newChargesTotals[action.payload.view]) +
            Number(state.decorationsTotals[action.payload.view]),
        },
      };
    }

    case t.ITEM_DIALOG_SET_DECORATIONS_TOTAL: {
      const newDecorationsTotals = {
        ...state.decorationsTotals,
        [action.payload.view]: action.payload.total,
      };
      return {
        ...state,
        decorationsTotals: newDecorationsTotals,
        subtotals: {
          ...state.subtotals,
          [action.payload.view]:
            Number(state.variantsTotals[action.payload.view]) +
            Number(state.chargesTotals[action.payload.view]) +
            Number(newDecorationsTotals[action.payload.view]),
        },
      };
    }

    case t.ITEM_DIALOG_SET_CHARGES:
      return {
        ...state,
        charges: {
          ...state.charges,
          [action.payload.view]: action.payload.charges,
        },
      };

    case t.ITEM_DIALOG_SET_DECORATION:
      return {
        ...state,
        decorations: {
          ...state.decorations,
          [action.payload.view]: action.payload.decoration,
        },
      };

    case t.ITEM_DIALOG_SET_VARIANTS:
      return {
        ...state,
        variants: action.payload,
      };

    case t.ITEM_DIALOG_SET_IMAGES:
      return {
        ...state,
        images: action.payload,
      };

    case t.ITEM_DIALOG_SET_VARIANT_SCHEMA:
      return {
        ...state,
        variantSchema: action.payload,
      };

    case t.ITEM_DIALOG_RESET:
      return initialState;

    default:
      return state;
  }
}

